<template>
    <div class="copy-panel">
        <span class="material-icons" style="font-size: 30px">ads_click</span>
        <span class="text">{{ $t('auto.copyPanelSelectTheRightPlaceToCopyToBlock') }}</span>
        <a-button type="primary" @click="changeCopyMode(null)"> {{ $t('auto.copyPanelCancel') }}</a-button>
    </div>
</template>

<script>
export default {
    name: "CopyPanel",
    props: ["changeCopyMode"],
};
</script>

<style lang="scss" scoped>
.copy-panel {
    position: absolute;
    top: 1rem;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    z-index: 999;
    display: flex;
    gap: 6px;
    background: #fff;
    align-items: center;
    border-radius: 4px;
    padding: 15px 15px;
    width: 520px;
    justify-content: space-between;

    .text {
        font-weight: 600;
        margin: 0px 20px;
        font-size: 18px;
        line-height: 23px;
    }
}
</style>
